import { render, staticRenderFns } from "./ResultsService.vue?vue&type=template&id=32c32138&"
import script from "./ResultsService.vue?vue&type=script&lang=js&"
export * from "./ResultsService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports